import * as React from 'react';
import { times } from 'ramda';
import { ActorApiTable, ActorApiTableProps } from '../../../../../../components';
import { useAccountDocumentsList } from '../../hooks';
import { AccountDocument } from '../../type';

export const AccountDocumentsTable = (props: React.PropsWithChildren<Pick<ActorApiTableProps, 'direction' | 'wrapping' | 'multiBody' | 'secondaryDimensionList'> & {
  filterPredicate?: ((data: AccountDocument) => boolean),
  sortPredicate?: (prev: AccountDocument, next: AccountDocument) => number,
  loadingLength: number,
}>) => {
  const {
    direction,
    wrapping,
    multiBody,
    secondaryDimensionList,
    filterPredicate,
    sortPredicate,
    loadingLength,
    children,
  } = props;
  const loadingValue = React.useMemo(() => times((i) => `${-i}`, loadingLength), [loadingLength]);
  const {
    data,
    isLoading,
    error,
  } = useAccountDocumentsList({
    filterPredicate,
    sortPredicate,
  });
  return (
    <ActorApiTable
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue={loadingValue}
      direction={direction}
      wrapping={wrapping}
      multiBody={multiBody}
      secondaryDimensionList={secondaryDimensionList}
    >
      {children}
    </ActorApiTable>
  );
};
